<template>
  <div class="applyinfo" v-if="objectCodeInfo">
    <a
      class="applyinfo__toggle"
      @click="showapplyinfo = !showapplyinfo"
      :aria-expanded="String(showapplyinfo)">
      Vilka regler gäller för intresse&shy;anmälningar?
    </a>
    <div class="applyinfo__text" v-html="objectCodeInfo"></div>
  </div>
</template>

<script>
export default {
  props: {
    objectCodeInfo: {
      type: String,
      required: true,
    },
  },
  components: {},
  data() {
    return {
      showapplyinfo: false,
    };
  },

  watch: {},

  methods: {},

  created() {},
};
</script>

<style lang="scss">
.applyinfo, .object__applyinfo {

  border-radius: 4px;
  border: solid 1px $lightgray;
  background-color: $offwhite;
  width: 100%;
  //max-width: 820px;
  margin-bottom: 30px;

  &__toggle {
    $root: &;
    position: relative;
    display: block;
    padding: 20px 57px 20px 16px;
    font-size: 18px;
    line-height: 25px;
    text-decoration: none;
    color: #000;
    font-weight: bold;
    cursor: pointer;

    &:hover, &:active {
      text-decoration: none;
      color: $abgblue;

      #{$root}:after & {
        border-color: $abgblue;
      }

    }

    &:after {
      content: '';
      border: solid black;
      border-width: 0 3px 3px 0;
      display: inline-block;
      padding: 3px;
      transform: rotate(45deg);
      -webkit-transform: rotate(45deg);
      transition: all 0.3s;
      position: absolute;
      right: 30px;
      top: calc(50% - 4px)
    }

    &[aria-expanded=true]:after {
      transform: rotate(-135deg);
      -webkit-transform: rotate(-135deg);
    }
  }


  h3, &__title {
    font-size: 16px;
    color: $darkgray;
  }

  &__text {
    display: none;
    font-size: 16px;
    padding: 0 20px 40px;
  }

  &__toggle[aria-expanded="true"] ~ &__text {
    display: block;
    padding-top: 20px;
    background-color: #fff;
    border-radius: 0 0 4px 4px;
    border-top: solid 1px $lightgray;
  }

  &__list {
    padding-left: 15px;
    margin-top: -22px;
    margin-bottom: 10px;

    &:before {
      color: $abgyellow;
      content: "\25AA";
      font-size: 16px;
      padding-right: 22px;
      position: relative;
      top: 22px;
      left: -22px;
    }
  }
}
</style>
